var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerbox"},[_c('img',{staticClass:"headerIcon",attrs:{"src":_vm.userIcon},on:{"click":function($event){return _vm.toLogin()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }